import { useState, useEffect, useRef } from "react";
import api from "../api";

export default function EmailVerification({ gardener, message, onClose, onVerified }) {
    const [email, setEmail] = useState(gardener.email || "");
    const [stage, setStage] = useState(gardener.email ? "code" : "email");
    const [verificationCode, setVerificationCode] = useState("");
    const [verificationError, setVerificationError] = useState("");

const initialSendRef = useRef(false);

useEffect(() => {
    if (stage === "code" && !initialSendRef.current) {
        initialSendRef.current = true;
        api.post("/gardeners/sendVerificationEmail", {
            gardenerID: gardener.id,
            email: gardener.email
        });
    }
}, [stage]);


    // -----------------------------
    // SEND VERIFICATION CODE
    // -----------------------------
    const sendCode = async () => {
        if (!email || email.trim() === "") {
            setVerificationError("Please enter your email.");
            return;
        }

        let error = "";

        // try and send 6 digit
        try {
            await api.post("/gardeners/sendVerificationEmail", { gardenerID: gardener.id, email });
            setVerificationError("");
            setStage("code");
        } catch (err) {
        const code = err.response?.data?.error;

        setVerificationError(err.response?.data?.error || "Request failed.");
        }
    };

    // -----------------------------
    // VERIFY CODE
    // -----------------------------
    const verifyCode = async () => {
        try {
            const res = await api.post("/gardeners/verifyEmailCode", {
                gardenerID: gardener.id,
                email,
                code: verificationCode
            });

            if (res.data.success) {
                setVerificationError("");
                setVerificationCode("");

                // Parent refreshes gardener and continues flow
                if (onVerified) {
                    await onVerified(email);
                }

                onClose();
            } else {
                setVerificationError("Invalid or expired code.");
            }
        } catch (err) {
            const code = err.response?.data?.error;

            setVerificationError(
                "Verification failed. Try again."
            );
        }
    };

    // -----------------------------
    // RESEND CODE
    // -----------------------------
    const resendCode = async () => {
        try {
            await api.post("/gardeners/sendVerificationEmail", { gardenerID: gardener.id, email });
            setVerificationError("");
            setStage("code");
        } catch (err) {
        const code = err.response?.data?.error;

        if (code === "EMAIL_EXISTS") {
            setVerificationError("That email is already in use.");
            setStage("email");
            setVerificationCode("");
            return; // stay on email screen
        }

        setVerificationError(err.response?.data?.error || "Request failed.");
        }
    };

    return (
        <div className="verify-overlay">
            <div className="verify-box">
                {message && (
                    <h2 className="verification-message">
                        {message}
                    </h2>
                )}

                {/* EMAIL ENTRY STAGE */}
                {stage === "email" && (
                    <>
                        <h3>Verify Your Email</h3>
                        <p>We need your email so we can send preorder and subscription information.</p>

                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoFocus
                        />

                        {verificationError && <p className="error">{verificationError}</p>}

                        <button className="button" onClick={sendCode}>Send Verification Code</button>
                        <button className="button tertiary" onClick={onClose}>Cancel</button>
                    </>
                )}

                {/* CODE ENTRY STAGE */}
                {stage === "code" && (
                    <>
                        <h3>Verify Your Email</h3>
                        <p>We sent a 6-digit code to <strong>{email}</strong></p>

                        <input
                            type="text"
                            maxLength="6"
                            value={verificationCode}
                            onChange={(e) => setVerificationCode(e.target.value)}
                            autoFocus
                        />

                        {verificationError && <p className="error">{verificationError}</p>}

                        <button className="button" onClick={verifyCode}>Verify Email</button>
                        <button className="button secondary" onClick={resendCode}>Resend Code</button>

                        <button
                            className="button tertiary"
                            onClick={() => {
                                setStage("email");
                                setVerificationCode("");
                                setVerificationError("");
                            }}
                        >
                            Change Email
                        </button>

                        <button className="button tertiary" onClick={onClose}>Cancel</button>
                    </>
                )}

            </div>
        </div>
    );
}
